import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DynamicModelComponent } from '../../../feature-module/core/common/dynamic-model/dynamic-model.component';
import { ModalService } from '../../../feature-module/core/services/modal.service';
import { LoginModalComponent } from '../login-modal/login-modal.component';
import { AuthService } from '../../core/service/auth.service';
import { AbstractControl, FormControl, FormGroup, FormsModule,ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';

@Component({
  selector: 'app-forget-password-modal',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './forget-passord-modal.component.html',
  styleUrl: './forget-passord-modal.component.scss'
})
export class ForgetPassordModalComponent {

  email: FormControl = new FormControl('', [Validators.required, Validators.email]);
  otpData: any; // Adjust type as needed
  errorMessage: string | null = null;

  otpForm: FormGroup = new FormGroup({
    otpId: new FormControl('', [Validators.required]),
    otpCode: new FormControl('', [Validators.required]),
    newPassword: new FormControl('', [Validators.required, Validators.minLength(4)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(4)]),
    expiresAt: new FormControl('', [Validators.required]),
  }, { validators: this.passwordsMatchValidator });

  constructor(
    private readonly modalService: ModalService,
    private readonly compRef: DynamicModelComponent,
    private readonly authService: AuthService
  ) {
    // Initialization logic if needed
  }

  passwordsMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('newPassword')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  signIn() {
    this.close();
    this.modalService.open(LoginModalComponent, { size: 'md' }).subscribe();
  }

  close() {
    this.compRef.close();
  }

  changeEmail() {
    this.otpData = null;
  }

  resendOtp() {
    if (!this.otpData?.otpId) {
      this.errorMessage = 'OTP ID is required to resend the OTP.';
      return;
    } // Ensure otpId is available before making the request
    this.errorMessage = null; // Reset error message before making the request
    this.authService.resendOtp(this.otpData.otpId).subscribe({
      next: (response) => {
        console.log('OTP resent successfully:', response);
        this.otpData = response.data;
        this.otpForm.patchValue({
          otpId: this.otpData.otpId,
          expiresAt: this.otpData.expiresAt
        }); // Update the form with the new OTP data
      },
      error: (error) => {
        console.error('Error resending OTP:', error);
        this.errorMessage = error?.error?.message; // Display the error message
        // Handle error appropriately, e.g., show a notification
      }
    });
  }

  resetPassword() {
    this.errorMessage = null; // Reset error message before making the request
    this.authService.resetPassword(this.otpForm.value).subscribe({
      next: (data) => {
        console.log('Password reset successful:', data);
        this.signIn();
      }
      , error: (error) => {
        console.error('Error resetting password:', error);
        this.errorMessage = error?.error?.message; // Display the error message
        // Handle error appropriately, e.g., show a notification
      }
    });
  }

  forgotPassword() {
    if (this.email.invalid) {
      return;
    }
    this.errorMessage = null; // Reset error message before making the request
    const emailValue = this.email.value;
    this.authService.forgotPassword(emailValue).subscribe({
      next: (data) => {
        this.otpData = data;
         this.otpForm.patchValue({
          otpId: this.otpData.otpId,
          expiresAt: this.otpData.expiresAt
        }); // Update the form with the new OTP data

      },
      error: (error) => {
        console.error('Error resetting password:', error.error);
        this.errorMessage = error?.error?.message; // Display the error message
      }
    });
  }

}
